import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

const css = {
  tooltip: {
    width: '100%',
    height: 'auto',
    padding: '8px',
    backgroundColor: 'white',
    borderRadius: '1px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
  },
  header: { marginBottom: '3px', fontWeight: 'bold', fontSize: '12px' },
  content: { fontSize: '12px' },
  buttons: { display: 'flex', justifyContent: 'end' },
  arrowIcon: {
    position: 'absolute',
    top: -28,
    color: 'white',
    fontSize: '3rem',
  },
  popover: {
    mt: 2,
    maxWidth: '330px',
  },
};

const ProductTour = ({ anchorEl, step, stepsLength, content, onNext, onPrev }) => {
  return (
    <Popover
      open={true}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      disableRestoreFocus
      sx={css.popover}
      slotProps={{ sx: { overflow: 'visible', position: 'relative' } }}
    >
      <ArrowDropUpIcon sx={css.arrowIcon} />
      <Box sx={css.tooltip}>
        <Box sx={css.header}>
          Paso {step + 1} de {stepsLength}
        </Box>
        <Box sx={css.content}>{content}</Box>
        <Box sx={css.buttons}>
          {step > 0 && (
            <Button onClick={onPrev} size="small">
              Atrás
            </Button>
          )}
          <Button onClick={onNext} size="small">
            {step + 1 === stepsLength ? 'Finalizar' : 'Siguiente'}
          </Button>
        </Box>
      </Box>
    </Popover>
  );
};

ProductTour.propTypes = {
  anchorEl: PropTypes.instanceOf(HTMLInputElement).isRequired,
  step: PropTypes.number.isRequired,
  stepsLength: PropTypes.number.isRequired,
  content: PropTypes.string.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
};

export default ProductTour;
